import styles from "./styles/DashboardPage.module.scss";
import FontAwesome from "../../components/utilities/FontAwesome";
import Button from "../../components/utilities/Button";
import WatsonApi from "../../backends/WatsonApi";
import useSWRInfinite from "swr/infinite";
import DraftPageItem from "../../components/misc/DraftPageItem";
import classNames from 'classnames';
import {useStores} from "../../stores/useStores";

const containerClassName = classNames({
    [styles.draftContainer]: true,
    [styles.widget]: true,
})

export default function DraftPagesWidget() {
    const {organizationStore} = useStores();

    const {data, isLoading, setSize, isValidating, mutate} = useSWRInfinite((pageIndex, previousPageData) => {
        return JSON.stringify({
            page: pageIndex,
            key: "get-drafts",
        })
    }, async (key) => {
        const parsedKey = JSON.parse(key);
        const client = await WatsonApi();
        const response = await client.apis.organizations.organizations_list({
            organization_pk: organizationStore.organization.id,
            path__descendant_or_eq: organizationStore.organization.path,
            published: 0,
            permissions: 'editor',
            page_size: 20,
            ordering: "title",
            deleted: "false",
            type__in: [
                'organization',
                'school',
                'district',
                'collection',
                'classroom',
                'group',
                'department',
                'section',
                'team',
                'activity',
            ],
            expand: ['categories', 'title_organization'],
            page: parsedKey.page + 1,
        });
        const result = JSON.parse(response.data);
        return {
            organizations: result.data,
            total: result.meta.total,
        }
    }, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnMount: true,
    });

    const organizations = data?.reduce((acc, curr) => [...acc, ...curr.organizations], []) || [];
    const total = data?.[0].total;
    return (
        <div className={containerClassName}>
            <div>
                <div className={styles.title}>
                    <span>Draft Pages </span> {isLoading || <>{total}</>}
                </div>
            </div>
            <div className="sb-content-width">
                {isLoading ? (
                    <div style={{textAlign: "center"}}>
                        <FontAwesome
                            prefix={"fas"}
                            name={"fa-spinner"}
                            spin={true}
                            size={"2x"}
                        />
                    </div>
                ) : (
                    <div style={{textAlign: "center"}}>
                        {total === 0 &&
                            "You currently do not have editor access to any Draft pages. You can set a page to draft status to hide it from the public and find it here. "}
                    </div>
                )}
            </div>
            {organizations.map(organization => {
                return (
                    <DraftPageItem key={organization.id} organization={organization}/>
                );
            })}


            <div className={styles.viewMoreButton}>
                {!isLoading && organizations.length < total && (
                    <div>
                        <Button
                            disabled={isValidating}
                            onClick={() => setSize(v => v + 1)}
                        >
                            {isValidating ? (
                                <FontAwesome name={"fas fa-spinner"} spin/>
                            ) : (
                                "View More"
                            )}
                        </Button>
                    </div>
                )}
            </div>
            <div style={{textAlign: "center"}}>
                <hr/>
                <span>
                    When you create a new page, you can give it a status of “Draft.” To
                    toggle Published / Draft Status, visit the page’s settings icon.
                    Draft pages are not accessible to anyone without editor rights.
                </span>
            </div>
        </div>

    );
}
